// rc-upload 2.9.4
import upload from './src';

export default upload;
